import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import {
  ArrowDownwardRounded as ArrowDownIcon,
  ArrowUpwardRounded as ArrowUpIcon,
  Sort as SortIcon,
} from '@mui/icons-material';
export interface ITableColumn {
  label: string;
  accessor: string;
  textAlign?: 'left' | 'center' | 'right';
  sortable: boolean;
  width?: number;
}

export interface ITableHeader {
  columns: ITableColumn[];
  handleSorting: (accessor: any) => void;
}

interface TableGeneratorProps {
  columns: ITableColumn[];
  handleSorting: (field: string) => void;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  disableSorting?: boolean;
}

const TableHeaderGenerator: React.FC<TableGeneratorProps> = ({
  columns,
  handleSorting,
  sortField,
  sortOrder,
  disableSorting = false,
}) => {
  const columnWidth = 100 / columns.length;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
      <Grid container spacing={1} mb={1}>
        {columns.map(({ label, accessor, textAlign, sortable, width }) => {
          const sortIcon = sortable ? (
            sortField === accessor && sortOrder === 'asc' ? (
              <ArrowUpIcon sx={{ ml: 1, width: '20px' }} />
            ) : (
              sortField === accessor &&
              sortOrder === 'desc' && <ArrowDownIcon sx={{ ml: 1, width: '20px' }} />
            )
          ) : null;

          return (
            <Grid
              item
              xs={width || 2}
              key={accessor}
              sx={{ flexBasis: `${columnWidth}%`, display: 'flex', alignItems: 'center' }}
            >
              <Typography
                title={sortable && !disableSorting ? `Click to sort by ${label.toLowerCase()}` : ''}
                fontWeight="bold"
                onClick={() => sortable && !disableSorting && handleSorting(accessor)}
                sx={{
                  cursor: sortable && !disableSorting ? 'pointer' : 'not-allowed',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: textAlign || 'center',
                  width: '100%',
                }}
              >
                {sortable && <SortIcon sx={{ mr: 1 }} />}
                {label} {sortIcon}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default TableHeaderGenerator;
